module.exports = __webpack_public_path__ + "img/germany-external-causes-male.a3e187b5.png";